export const BOTTLE_SIZE = 4;

export const lvlConfig = [
  {lvl: 0, colors: 5},
  {lvl: 10, colors: 6},
  {lvl: 50, colors: 7},
  {lvl: 100, colors: 8},
  {lvl: 250, colors: 9},
  {lvl: 500, colors: 10},
  {lvl: 750, colors: 11},
  {lvl: 1000, colors: 12},
  {lvl: 1250, colors: 13},
  {lvl: 1500, colors: 14},
  {lvl: 1750, colors: 15},
  {lvl: 2000, colors: 16},
].reverse()
